import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];

  connect() {
    this.updateDisplay();
    window.addEventListener('color-scheme:changed', this.boundUpdate = () => this.updateDisplay());
  }

  disconnect() {
    window.removeEventListener('color-scheme:changed', this.boundUpdate);
  }

  toggle() {
    if (window.colorScheme) {
      const current = window.colorScheme.current;
      window.colorScheme.preference = current === "dark" ? "light" : "dark";
    } else {
      const currentTheme = localStorage.getItem("color_scheme_preference") || "light";
      const newTheme = currentTheme === "dark" ? "light" : "dark";
      document.documentElement.classList.remove("dark", "light");
      document.documentElement.classList.add(newTheme);
      localStorage.setItem("color_scheme_preference", newTheme);
    }
    this.updateDisplay();
  }

  updateDisplay() {
    const isDark = document.documentElement.classList.contains("dark");
    if (this.hasIconTarget) {
      if (isDark) {
        this.iconTarget.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-moon"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>`;
      } else {
        this.iconTarget.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sun"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41-1.41"/><path d="m19.07 4.93-1.41 1.41"/></svg>`;
      }
    }
  }
}
